import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SiteNotice() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('core829_cookie_consent');
        if (!consent) {
            // Small delay so it animates in nicely
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem('core829_cookie_consent', 'all');
        setIsVisible(false);
    };

    const handleAcceptNecessary = () => {
        localStorage.setItem('core829_cookie_consent', 'necessary');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 md:p-8 animate-in slide-in-from-bottom-10 fade-in duration-500 pointer-events-none">
            <div className="max-w-4xl mx-auto bg-dark-bg/95 backdrop-blur-md border border-white/10 rounded-2xl p-6 shadow-2xl shadow-red-900/10 pointer-events-auto flex flex-col md:flex-row gap-6 items-start md:items-center relative overflow-hidden">
                {/* Decorative background glow */}
                <div className="absolute top-0 left-0 w-64 h-64 bg-red-600/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />

                <div className="h-12 w-12 rounded-xl bg-red-500/10 flex items-center justify-center shrink-0">
                    <Cookie className="h-6 w-6 text-red-500" />
                </div>

                <div className="flex-1 space-y-2 relative z-10 font-inter">
                    <h3 className="text-lg font-semibold text-white">{t('app.site_notice.privacy_title')}</h3>
                    <p className="text-sm text-gray-400">
                        {t('app.site_notice.cookie_description')}{' '}
                        <Link to="/legal/cookie-policy" className="text-red-500 hover:text-red-400 font-medium underline underline-offset-2">
                            {t('app.site_notice.cookie_policy')}
                        </Link>.
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto shrink-0 relative z-10">
                    <Button
                        variant="outline"
                        onClick={handleAcceptNecessary}
                        className="bg-transparent border-white/20 hover:bg-white/5 text-gray-300 transition-colors"
                    >
                        {t('app.site_notice.only_necessary')}
                    </Button>
                    <Button
                        onClick={handleAcceptAll}
                        className="bg-red-600 hover:bg-red-500 text-white shadow-lg border-0 transition-colors"
                    >
                        {t('app.site_notice.accept_all')}
                    </Button>
                </div>

                <button
                    onClick={handleAcceptNecessary}
                    className="absolute top-4 right-4 text-slate-500 hover:text-white transition-colors p-1"
                    aria-label={t('app.site_notice.close_accept_necessary')}
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
